export default __webpack_public_path__ + "static/media/16-3D-(4-2).7e3fd48c.jpg";